import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFilter'
})
export class CurrencyFilterPipe implements PipeTransform {

  transform<T>(values: T[], filter: string, prop: string): Array<T> {
    if (filter && filter.length > 0) {
      return values.filter(v => v[prop].toUpperCase().includes(filter.toUpperCase()));
    }
    return values;
  }
}
